import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FaSpinner } from 'react-icons/fa';
import toast from 'react-hot-toast';
import { ColoredDownloadIcon } from 'ui-component/custom-icons/icons';
import * as XLSX from 'xlsx';
import ReactSelect from 'react-select';
import { allCountriesList } from 'assets/helperdata/countries-list';


// ✅ Clear
const ExportPopupModal = ({ isOpen, onClose, widgetType, widgetName }) => {
    const [isProcessing, setIsProcessing] = useState(false);
    const [selectedValues, setSelectedValues] = useState({
        startDate: null,
        endDate: null,
        orderBy: 'amount',
        sortBy: 'desc',
        currency: 'eur',
        countries: []
    });

    const orderByOptions = [
        { value: 'name', label: 'Name' },
        { value: 'amount', label: 'Amount' }
    ];
    const orderByCountryOptions = [
        { value: 'name', label: 'Country' },
    ];

    const sortByOptions = [
        { value: 'asc', label: 'Ascending' },
        { value: 'desc', label: 'Descending' }
    ];

    const currencyOptions = [
        { value: 'usd', label: 'USD' },
        { value: 'eur', label: 'EUR' },
        { value: 'aed', label: 'AED' }
    ];
    
    const handleSubmit = () => {
        let request = {
            start_date: selectedValues?.startDate,
            end_date: selectedValues?.endDate,
            order_by: selectedValues?.orderBy,
            sort_by: selectedValues?.sortBy,
            currency: selectedValues?.currency || 'EUR',
            widget_type: widgetType, 
            countries: selectedValues?.countries?.map((c) => c.value) || []
        }
        
        setIsProcessing(true);

        api.exportDashboardWidget(request).then((res) => {


            const wb = XLSX.utils.book_new();
            // Create a worksheet
            const ws = XLSX.utils.json_to_sheet(res?.data);
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

            // Convert the workbook to a binary string
            const wbBinaryString = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

            // Convert the binary string to a Blob
            const blob = new Blob([s2ab(wbBinaryString)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

            saveAs(blob, `Projectmix ${widgetName}.xlsx`);
            setIsProcessing(false);
            onClose();
            toast.success('Exported Successfully');
        });

    }
	const s2ab = (s) => {
		const buf = new ArrayBuffer(s.length);
		const view = new Uint8Array(buf);
		for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
		return buf;
    };
    
    useEffect(() => {
        if (widgetType === 'CONTACT-LOCATIONS') {
            setSelectedValues((oldData) => ({
                ...oldData,
                orderBy: 'name',
                sortBy: 'asc',
            }));
        } 
    }, [widgetType])


    return (
        <Modal show={'true'} onHide={onClose} centered size="sm">
            <Modal.Body>
                <div className="">
                    <div className="mb-2 ml-0 pl-0">
                        <div className="row" style={{ marginBottom: 20 }}>
                            <div className="col-12">
                                <button className="btn modal-close-icon" style={{ top: '-5px' }} onClick={onClose}>
                                    <svg
                                        id="Component_127_1"
                                        height="16"
                                        width="16"
                                        data-name="Component 127 – 1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 19.295 19.289"
                                    >
                                        <path
                                            id="Icon_ionic-ios-close"
                                            data-name="Icon ionic-ios-close"
                                            d="M23.219,20.933l6.891-6.891a1.615,1.615,0,0,0-2.284-2.284L20.935,18.65l-6.891-6.891a1.615,1.615,0,1,0-2.284,2.284l6.891,6.891L11.76,27.825a1.615,1.615,0,1,0,2.284,2.284l6.891-6.891,6.891,6.891a1.615,1.615,0,1,0,2.284-2.284Z"
                                            transform="translate(-11.285 -11.289)"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div
                            style={{
                                padding: '0 10px',
                            }}
                        >

                                <div className="row">
                                    <div className="col-12 text-center">
                                        <div style={{ marginBottom: '20px' }}>
                                            <ColoredDownloadIcon width={'75px'} height={'75px'} />
                                        </div>
                                        <div>
                                            <h4 style={{ marginBottom: 0, fontWeight: 600, paddingBottom: '10px' }}>Export {widgetName}</h4>
                                        </div>
                                        <div>

                                            <label style={{ color: '#595959' }} className="fw-500">
                                                Export your data by selecting a custom date range below.
                                            </label>
                                        </div>
                                </div>
                                {
                                    widgetType === 'CONTACT-LOCATIONS' ? (
                                        <>
                                            <div className="col-lg-12 col-md-12 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
                                                <label style={{ color: '#595959' }} className="fw-500">Countries</label>
                                                <ReactSelect
                                                    className="rs-container"
                                                    classNamePrefix="rs"
                                                    options={allCountriesList?.map((y) => ({ label: y.name, value: y.code }))}
                                                    onChange={(e) => {
                                                        setSelectedValues((oldData) => ({
                                                            ...oldData,
                                                            countries: e
                                                        }));
                                                    }}
                                                    isMulti={true}
                                                    menuPlacement="auto"
                                                    menuPosition="fixed"
                                                    placeholder="Select or type..."
                                                />
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
                                                <label style={{ color: '#595959' }} className="fw-500">Order By</label>
                                
                                                <ReactSelect
                                                    className="rs-filter-container"
                                                    classNamePrefix="rs-filter"
                                                    options={orderByCountryOptions}
                                                    value={ orderByCountryOptions?.find((option) => option.value === selectedValues['orderBy']) }
                                                    onChange={(e) => {
                                                        setSelectedValues((oldData) => ({
                                                            ...oldData,
                                                            orderBy: e?.value
                                                        }));
                                                    }}
                                                />
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
                                                <label style={{ color: '#595959' }} className="fw-500">Sort By</label>
                                
                                                <ReactSelect
                                                    className="rs-filter-container"
                                                    classNamePrefix="rs-filter"
                                                    options={sortByOptions}
                                                    value={ sortByOptions?.find((option) => option.value === selectedValues['sortBy']) }
                                                    onChange={(e) => {
                                                        setSelectedValues((oldData) => ({
                                                            ...oldData,
                                                            sortBy: e?.value
                                                        }));
                                                    }}
                                                />
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="col-lg-12 col-md-12 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
                                                <label style={{ color: '#595959' }} className="fw-500">Start Date</label>
                                                <input
                                                    type="date"
                                                    value={selectedValues?.startDate || ''}    
                                                    style={{ cursor: 'pointer' }}
                                                    className="form-control form-inp"
                                                    onClick={(e) => e.target.focus()}
                                                    onChange={(e) => {
                                                        setSelectedValues((oldData) => ({
                                                            ...oldData,
                                                            startDate: e?.target?.value
                                                        }));
                                                    }}
                                                />
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
                                                <label style={{ color: '#595959' }} className="fw-500">End Date</label>

                                                <input
                                                    type="date"
                                                    style={{ cursor: 'pointer' }}
                                                    className="form-control form-inp"
                                                    onClick={(e) => e.target.focus()}
                                                    value={selectedValues?.endDate || ''}
                                                    onChange={(e) => {
                                                        setSelectedValues((oldData) => ({
                                                            ...oldData,
                                                            endDate: e?.target?.value
                                                        }));
                                                    }}
                                                />
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
                                                <label style={{ color: '#595959' }} className="fw-500">Currency</label>
                                
                                                <ReactSelect
                                                    className="rs-filter-container"
                                                    classNamePrefix="rs-filter"
                                                    options={currencyOptions}
                                                    value={currencyOptions?.find((option) => option.value === selectedValues['currency']) }
                                                    onChange={(e) => {
                                                        setSelectedValues((oldData) => ({
                                                            ...oldData,
                                                            currency: e?.value
                                                        }));
                                                    }}
                                                />
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
                                                <label style={{ color: '#595959' }} className="fw-500">Order By</label>
                                
                                                <ReactSelect
                                                    className="rs-filter-container"
                                                    classNamePrefix="rs-filter"
                                                    options={orderByOptions}
                                                    value={ orderByOptions?.find((option) => option.value === selectedValues['orderBy']) }
                                                    onChange={(e) => {
                                                        setSelectedValues((oldData) => ({
                                                            ...oldData,
                                                            orderBy: e?.value
                                                        }));
                                                    }}
                                                />
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-sm-12 mb-3" style={{ marginBottom: 5 }}>
                                                <label style={{ color: '#595959' }} className="fw-500">Sort By</label>
                                
                                                <ReactSelect
                                                    className="rs-filter-container"
                                                    classNamePrefix="rs-filter"
                                                    options={sortByOptions}
                                                    value={ sortByOptions?.find((option) => option.value === selectedValues['sortBy']) }
                                                    onChange={(e) => {
                                                        setSelectedValues((oldData) => ({
                                                            ...oldData,
                                                            sortBy: e?.value
                                                        }));
                                                    }}
                                                />
                                            </div>
                                        </>
                                    )
                                }
                                </div>
                                <div className="row" style={{ marginTop: '10px' }}>
                                    <div className="col-12">
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                                            <button
                                                className={`btn btn-primary btn-outlined-danger`}
                                                onClick={() => {
                                                    onClose();
                                                }}
                                            >
                                                Close 
                                            </button>
                                            <button
                                                className={`btn btn-primary  btn-outlined-main-primary ${isProcessing ? 'disabled' : ''}`}
                                                disabled={isProcessing ? true : false}
                                                onClick={() => {
                                                    if (!isProcessing) {
                                                        handleSubmit()
                                                    }
                                                }}
                                            >
                                                {
                                                    isProcessing ? (
                                                        <>
                                                            <FaSpinner className='spinner' style={{ height: '15px', width: '25px', marginRight: '0px' }} /> Processing... 
                                                        </>
                                                    ) : (
                                                        'Export'
                                                    )
                                                }
                                                
                                            </button>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ExportPopupModal;
